import {Box} from '@mui/material';

import RegistrationLink from './registration-link';
import AccessCodes from './access-codes';
import {AccessCode} from '@/types/company';

interface RegistrationDetailsProps {
  registerLink: string;
  accessCodes: AccessCode[] | undefined;
}

const RegistrationDetails: React.FC<RegistrationDetailsProps> = ({
  registerLink,
  accessCodes
}) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      width="100%"
      justifyContent="center"
      alignItems="center"
      marginTop={2}
    >
      <RegistrationLink registerLink={registerLink} />
      <AccessCodes accessCodes={accessCodes} />
    </Box>
  );
};

export default RegistrationDetails;
